import axios from "axios";
import useConstants from "constants";

const useAuth = () => {
  const { AUTH_URL, AUTH_API_URL, ADMIN_API_URL, GWM_API_URL, ERM_APP_URL } = useConstants();

  const BASE_URL = AUTH_API_URL;
  const ADMIN_BASE_URL = ADMIN_API_URL;
  const GWM_BASE_URL = GWM_API_URL;

  const saveTokens = (tokens) => {
    localStorage.setItem("__at_um", tokens.access);
    localStorage.setItem("__rt_um", tokens.refresh);
  };

  const user =
    sessionStorage.getItem("user") !== "undefined" && sessionStorage.getItem("user") !== "null"
      ? JSON.parse(sessionStorage.getItem("user"))
      : {};

  const saveUser = (user) => {
    sessionStorage.setItem("user", JSON.stringify(user));
  };

  const getAccessToken = () => localStorage.getItem("__at_um");
  const getRefreshToken = () => localStorage.getItem("__rt_um");

  const refreshAccessToken = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/authentication/refresh/`,
        { platform: "gwm" },
        {
          withCredentials: true,
          headers: {
            "use-cookie-auth": "true",
          },
        }
      );
      saveTokens({ access: response.data.access, refresh: response.data.refresh });
      saveUser(response.data.user_data);
      return response.data.access;
    } catch (error) {
      console.error("Token refresh failed", error);
      throw error;
    }
  };

  const cleanUp = (redirect_url = ERM_APP_URL) => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.assign(`${redirect_url}`);
  };

  const logout = async () => {
    cleanUp(`${ERM_APP_URL}/logout`);
  };

  return {
    BASE_URL,
    ADMIN_BASE_URL,
    GWM_BASE_URL,
    saveTokens,
    saveUser,
    getAccessToken,
    getRefreshToken,
    refreshAccessToken,
    logout,
    user,
    cleanUp,
  };
};

export default useAuth;
